var swiper = new Swiper(".custom-reviews-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 40
        },
        1280: {
            slidesPerView: 3,
            spaceBetween: 40
        }        

    },    
    // autoplay: {
    //     delay: 8000,
    //     disableOnInteraction: true,
    //   },
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});